import { Box } from "@mui/material";

import ExpandImage from "./Expand";
import Img from "./Img";

export default function ImageFragment({ imgScale, avgLineHeight, fragment }) {
  const { alt, src, inline } = fragment;

  return (
    <Box
      component="span"
      // display="inline"
      sx={{
        verticalAlign: "middle",
        "& img": {
          imageRendering: "-webkit-optimize-contrast"
        },
        ...(inline
          ? { px: "1ch" }
          : {
              // p: 2,
              // pt: 0.5,
              // width: "auto",
              // height: "auto",
              // border: 1,
              // display: "block"
              // borderRadius: "16px",
              // borderColor: "outline.variant"
            })
      }}
    >
      {inline ? null : <ExpandImage src={src} alt={alt} />}
      <Img
        imgScale={imgScale}
        avgLineHeight={avgLineHeight}
        fragment={fragment}
      />
    </Box>
  );
}
